import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=2d4611a7&scoped=true&"
import script from "./Aside.vue?vue&type=script&setup=true&lang=js&"
export * from "./Aside.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Aside.vue?vue&type=style&index=0&id=2d4611a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4611a7",
  null
  
)

export default component.exports